export default {"src":"/_next/static/media/weEmpowerBG.5bb37b08.svg","height":362,"width":1095,"blurWidth":0,"blurHeight":0};